import { apiFetch } from "../api.js";
import type {
  CreateScenarioInput,
  Scenario,
  ScenariosListResponse,
  UpdateScenarioInput,
} from "./types.js";

/**
 * Phase 6 Session 4 — scenarios CRUD client. Mirrors the bills/notes
 * api-module shape: 5 functions wrapping `apiFetch` against the
 * Scenarios Lambdalith in `Hearth-Dev-Api-Cashflow`.
 *
 * - Soft-delete: `deleteScenario(id)` sets `is_archived=true` server-
 *   side. Returns 204 idempotently on already-archived rows.
 * - List: defaults to `is_archived=false`; pass `includeArchived=true`
 *   to surface the archived view (for the SPA's archive-history tab).
 */

export function listScenarios(
  includeArchived = false,
): Promise<ScenariosListResponse> {
  const qs = includeArchived ? "?include_archived=true" : "";
  return apiFetch<ScenariosListResponse>(`/v1/scenarios${qs}`);
}

export function getScenario(scenarioId: string): Promise<Scenario> {
  return apiFetch<Scenario>(
    `/v1/scenarios/${encodeURIComponent(scenarioId)}`,
  );
}

export function createScenario(input: CreateScenarioInput): Promise<Scenario> {
  return apiFetch<Scenario>("/v1/scenarios", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateScenario(
  scenarioId: string,
  input: UpdateScenarioInput,
): Promise<Scenario> {
  return apiFetch<Scenario>(`/v1/scenarios/${encodeURIComponent(scenarioId)}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteScenario(scenarioId: string): Promise<void> {
  return apiFetch<void>(`/v1/scenarios/${encodeURIComponent(scenarioId)}`, {
    method: "DELETE",
  });
}
